/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(14);
	
	var _preact = __webpack_require__(1);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	var root = void 0;
	function init() {
	
	  // warm up heroku so its ready by the time we load /book
	  fetch(("https://rosenthal-fitness.herokuapp.com"));
	
	  var App = __webpack_require__(3).default;
	  root = (0, _preact.render)((0, _preact.h)(App, null), document.body, root);
	}
	
	init();
	
	if (false) {
	  module.hot.accept('./components/app', function () {
	    return requestAnimationFrame(init);
	  });
	}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	!function(global, factory) {
	     true ? factory(exports) : 'function' == typeof define && define.amd ? define([ 'exports' ], factory) : factory(global.preact = global.preact || {});
	}(this, function(exports) {
	    function VNode(nodeName, attributes, children) {
	        this.nodeName = nodeName;
	        this.attributes = attributes;
	        this.children = children;
	        this.key = attributes && attributes.key;
	    }
	    function h(nodeName, attributes) {
	        var children, lastSimple, child, simple, i;
	        for (i = arguments.length; i-- > 2; ) stack.push(arguments[i]);
	        if (attributes && attributes.children) {
	            if (!stack.length) stack.push(attributes.children);
	            delete attributes.children;
	        }
	        while (stack.length) if ((child = stack.pop()) instanceof Array) for (i = child.length; i--; ) stack.push(child[i]); else if (null != child && child !== !0 && child !== !1) {
	            if ('number' == typeof child) child = String(child);
	            simple = 'string' == typeof child;
	            if (simple && lastSimple) children[children.length - 1] += child; else {
	                (children || (children = [])).push(child);
	                lastSimple = simple;
	            }
	        }
	        var p = new VNode(nodeName, attributes || void 0, children || EMPTY_CHILDREN);
	        if (options.vnode) options.vnode(p);
	        return p;
	    }
	    function extend(obj, props) {
	        if (props) for (var i in props) obj[i] = props[i];
	        return obj;
	    }
	    function clone(obj) {
	        return extend({}, obj);
	    }
	    function delve(obj, key) {
	        for (var p = key.split('.'), i = 0; i < p.length && obj; i++) obj = obj[p[i]];
	        return obj;
	    }
	    function isFunction(obj) {
	        return 'function' == typeof obj;
	    }
	    function isString(obj) {
	        return 'string' == typeof obj;
	    }
	    function hashToClassName(c) {
	        var str = '';
	        for (var prop in c) if (c[prop]) {
	            if (str) str += ' ';
	            str += prop;
	        }
	        return str;
	    }
	    function cloneElement(vnode, props) {
	        return h(vnode.nodeName, extend(clone(vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
	    }
	    function createLinkedState(component, key, eventPath) {
	        var path = key.split('.');
	        return function(e) {
	            var t = e && e.target || this, state = {}, obj = state, v = isString(eventPath) ? delve(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e, i = 0;
	            for (;i < path.length - 1; i++) obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
	            obj[path[i]] = v;
	            component.setState(state);
	        };
	    }
	    function enqueueRender(component) {
	        if (!component._dirty && (component._dirty = !0) && 1 == items.push(component)) (options.debounceRendering || defer)(rerender);
	    }
	    function rerender() {
	        var p, list = items;
	        items = [];
	        while (p = list.pop()) if (p._dirty) renderComponent(p);
	    }
	    function isFunctionalComponent(vnode) {
	        var nodeName = vnode && vnode.nodeName;
	        return nodeName && isFunction(nodeName) && !(nodeName.prototype && nodeName.prototype.render);
	    }
	    function buildFunctionalComponent(vnode, context) {
	        return vnode.nodeName(getNodeProps(vnode), context || EMPTY);
	    }
	    function isSameNodeType(node, vnode) {
	        if (isString(vnode)) return node instanceof Text;
	        if (isString(vnode.nodeName)) return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	        if (isFunction(vnode.nodeName)) return (node._componentConstructor ? node._componentConstructor === vnode.nodeName : !0) || isFunctionalComponent(vnode); else return;
	    }
	    function isNamedNode(node, nodeName) {
	        return node.normalizedNodeName === nodeName || toLowerCase(node.nodeName) === toLowerCase(nodeName);
	    }
	    function getNodeProps(vnode) {
	        var props = clone(vnode.attributes);
	        props.children = vnode.children;
	        var defaultProps = vnode.nodeName.defaultProps;
	        if (defaultProps) for (var i in defaultProps) if (void 0 === props[i]) props[i] = defaultProps[i];
	        return props;
	    }
	    function removeNode(node) {
	        var p = node.parentNode;
	        if (p) p.removeChild(node);
	    }
	    function setAccessor(node, name, old, value, isSvg) {
	        if ('className' === name) name = 'class';
	        if ('class' === name && value && 'object' == typeof value) value = hashToClassName(value);
	        if ('key' === name) ; else if ('class' === name && !isSvg) node.className = value || ''; else if ('style' === name) {
	            if (!value || isString(value) || isString(old)) node.style.cssText = value || '';
	            if (value && 'object' == typeof value) {
	                if (!isString(old)) for (var i in old) if (!(i in value)) node.style[i] = '';
	                for (var i in value) node.style[i] = 'number' == typeof value[i] && !NON_DIMENSION_PROPS[i] ? value[i] + 'px' : value[i];
	            }
	        } else if ('dangerouslySetInnerHTML' === name) {
	            if (value) node.innerHTML = value.__html || '';
	        } else if ('o' == name[0] && 'n' == name[1]) {
	            var l = node._listeners || (node._listeners = {});
	            name = toLowerCase(name.substring(2));
	            if (value) {
	                if (!l[name]) node.addEventListener(name, eventProxy, !!NON_BUBBLING_EVENTS[name]);
	            } else if (l[name]) node.removeEventListener(name, eventProxy, !!NON_BUBBLING_EVENTS[name]);
	            l[name] = value;
	        } else if ('list' !== name && 'type' !== name && !isSvg && name in node) {
	            setProperty(node, name, null == value ? '' : value);
	            if (null == value || value === !1) node.removeAttribute(name);
	        } else {
	            var ns = isSvg && name.match(/^xlink\:?(.+)/);
	            if (null == value || value === !1) if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1])); else node.removeAttribute(name); else if ('object' != typeof value && !isFunction(value)) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', toLowerCase(ns[1]), value); else node.setAttribute(name, value);
	        }
	    }
	    function setProperty(node, name, value) {
	        try {
	            node[name] = value;
	        } catch (e) {}
	    }
	    function eventProxy(e) {
	        return this._listeners[e.type](options.event && options.event(e) || e);
	    }
	    function collectNode(node) {
	        removeNode(node);
	        if (node instanceof Element) {
	            node._component = node._componentConstructor = null;
	            var _name = node.normalizedNodeName || toLowerCase(node.nodeName);
	            (nodes[_name] || (nodes[_name] = [])).push(node);
	        }
	    }
	    function createNode(nodeName, isSvg) {
	        var name = toLowerCase(nodeName), node = nodes[name] && nodes[name].pop() || (isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName));
	        node.normalizedNodeName = name;
	        return node;
	    }
	    function flushMounts() {
	        var c;
	        while (c = mounts.pop()) {
	            if (options.afterMount) options.afterMount(c);
	            if (c.componentDidMount) c.componentDidMount();
	        }
	    }
	    function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	        if (!diffLevel++) {
	            isSvgMode = parent && void 0 !== parent.ownerSVGElement;
	            hydrating = dom && !(ATTR_KEY in dom);
	        }
	        var ret = idiff(dom, vnode, context, mountAll);
	        if (parent && ret.parentNode !== parent) parent.appendChild(ret);
	        if (!--diffLevel) {
	            hydrating = !1;
	            if (!componentRoot) flushMounts();
	        }
	        return ret;
	    }
	    function idiff(dom, vnode, context, mountAll) {
	        var ref = vnode && vnode.attributes && vnode.attributes.ref;
	        while (isFunctionalComponent(vnode)) vnode = buildFunctionalComponent(vnode, context);
	        if (null == vnode) vnode = '';
	        if (isString(vnode)) {
	            if (dom && dom instanceof Text && dom.parentNode) {
	                if (dom.nodeValue != vnode) dom.nodeValue = vnode;
	            } else {
	                if (dom) recollectNodeTree(dom);
	                dom = document.createTextNode(vnode);
	            }
	            return dom;
	        }
	        if (isFunction(vnode.nodeName)) return buildComponentFromVNode(dom, vnode, context, mountAll);
	        var out = dom, nodeName = String(vnode.nodeName), prevSvgMode = isSvgMode, vchildren = vnode.children;
	        isSvgMode = 'svg' === nodeName ? !0 : 'foreignObject' === nodeName ? !1 : isSvgMode;
	        if (!dom) out = createNode(nodeName, isSvgMode); else if (!isNamedNode(dom, nodeName)) {
	            out = createNode(nodeName, isSvgMode);
	            while (dom.firstChild) out.appendChild(dom.firstChild);
	            if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	            recollectNodeTree(dom);
	        }
	        var fc = out.firstChild, props = out[ATTR_KEY];
	        if (!props) {
	            out[ATTR_KEY] = props = {};
	            for (var a = out.attributes, i = a.length; i--; ) props[a[i].name] = a[i].value;
	        }
	        if (!hydrating && vchildren && 1 === vchildren.length && 'string' == typeof vchildren[0] && fc && fc instanceof Text && !fc.nextSibling) {
	            if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
	        } else if (vchildren && vchildren.length || fc) innerDiffNode(out, vchildren, context, mountAll, !!props.dangerouslySetInnerHTML);
	        diffAttributes(out, vnode.attributes, props);
	        if (ref) (props.ref = ref)(out);
	        isSvgMode = prevSvgMode;
	        return out;
	    }
	    function innerDiffNode(dom, vchildren, context, mountAll, absorb) {
	        var j, c, vchild, child, originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren && vchildren.length;
	        if (len) for (var i = 0; i < len; i++) {
	            var _child = originalChildren[i], props = _child[ATTR_KEY], key = vlen ? (c = _child._component) ? c.__key : props ? props.key : null : null;
	            if (null != key) {
	                keyedLen++;
	                keyed[key] = _child;
	            } else if (hydrating || absorb || props || _child instanceof Text) children[childrenLen++] = _child;
	        }
	        if (vlen) for (var i = 0; i < vlen; i++) {
	            vchild = vchildren[i];
	            child = null;
	            var key = vchild.key;
	            if (null != key) {
	                if (keyedLen && key in keyed) {
	                    child = keyed[key];
	                    keyed[key] = void 0;
	                    keyedLen--;
	                }
	            } else if (!child && min < childrenLen) for (j = min; j < childrenLen; j++) {
	                c = children[j];
	                if (c && isSameNodeType(c, vchild)) {
	                    child = c;
	                    children[j] = void 0;
	                    if (j === childrenLen - 1) childrenLen--;
	                    if (j === min) min++;
	                    break;
	                }
	            }
	            child = idiff(child, vchild, context, mountAll);
	            if (child && child !== dom) if (i >= len) dom.appendChild(child); else if (child !== originalChildren[i]) {
	                if (child === originalChildren[i + 1]) removeNode(originalChildren[i]);
	                dom.insertBefore(child, originalChildren[i] || null);
	            }
	        }
	        if (keyedLen) for (var i in keyed) if (keyed[i]) recollectNodeTree(keyed[i]);
	        while (min <= childrenLen) {
	            child = children[childrenLen--];
	            if (child) recollectNodeTree(child);
	        }
	    }
	    function recollectNodeTree(node, unmountOnly) {
	        var component = node._component;
	        if (component) unmountComponent(component, !unmountOnly); else {
	            if (node[ATTR_KEY] && node[ATTR_KEY].ref) node[ATTR_KEY].ref(null);
	            if (!unmountOnly) collectNode(node);
	            var c;
	            while (c = node.lastChild) recollectNodeTree(c, unmountOnly);
	        }
	    }
	    function diffAttributes(dom, attrs, old) {
	        var name;
	        for (name in old) if (!(attrs && name in attrs) && null != old[name]) setAccessor(dom, name, old[name], old[name] = void 0, isSvgMode);
	        if (attrs) for (name in attrs) if (!('children' === name || 'innerHTML' === name || name in old && attrs[name] === ('value' === name || 'checked' === name ? dom[name] : old[name]))) setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
	    }
	    function collectComponent(component) {
	        var name = component.constructor.name, list = components[name];
	        if (list) list.push(component); else components[name] = [ component ];
	    }
	    function createComponent(Ctor, props, context) {
	        var inst = new Ctor(props, context), list = components[Ctor.name];
	        Component.call(inst, props, context);
	        if (list) for (var i = list.length; i--; ) if (list[i].constructor === Ctor) {
	            inst.nextBase = list[i].nextBase;
	            list.splice(i, 1);
	            break;
	        }
	        return inst;
	    }
	    function setComponentProps(component, props, opts, context, mountAll) {
	        if (!component._disable) {
	            component._disable = !0;
	            if (component.__ref = props.ref) delete props.ref;
	            if (component.__key = props.key) delete props.key;
	            if (!component.base || mountAll) {
	                if (component.componentWillMount) component.componentWillMount();
	            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
	            if (context && context !== component.context) {
	                if (!component.prevContext) component.prevContext = component.context;
	                component.context = context;
	            }
	            if (!component.prevProps) component.prevProps = component.props;
	            component.props = props;
	            component._disable = !1;
	            if (0 !== opts) if (1 === opts || options.syncComponentUpdates !== !1 || !component.base) renderComponent(component, 1, mountAll); else enqueueRender(component);
	            if (component.__ref) component.__ref(component);
	        }
	    }
	    function renderComponent(component, opts, mountAll, isChild) {
	        if (!component._disable) {
	            var skip, rendered, inst, cbase, props = component.props, state = component.state, context = component.context, previousProps = component.prevProps || props, previousState = component.prevState || state, previousContext = component.prevContext || context, isUpdate = component.base, nextBase = component.nextBase, initialBase = isUpdate || nextBase, initialChildComponent = component._component;
	            if (isUpdate) {
	                component.props = previousProps;
	                component.state = previousState;
	                component.context = previousContext;
	                if (2 !== opts && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === !1) skip = !0; else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
	                component.props = props;
	                component.state = state;
	                component.context = context;
	            }
	            component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	            component._dirty = !1;
	            if (!skip) {
	                if (component.render) rendered = component.render(props, state, context);
	                if (component.getChildContext) context = extend(clone(context), component.getChildContext());
	                while (isFunctionalComponent(rendered)) rendered = buildFunctionalComponent(rendered, context);
	                var toUnmount, base, childComponent = rendered && rendered.nodeName;
	                if (isFunction(childComponent)) {
	                    var childProps = getNodeProps(rendered);
	                    inst = initialChildComponent;
	                    if (inst && inst.constructor === childComponent && childProps.key == inst.__key) setComponentProps(inst, childProps, 1, context); else {
	                        toUnmount = inst;
	                        inst = createComponent(childComponent, childProps, context);
	                        inst.nextBase = inst.nextBase || nextBase;
	                        inst._parentComponent = component;
	                        component._component = inst;
	                        setComponentProps(inst, childProps, 0, context);
	                        renderComponent(inst, 1, mountAll, !0);
	                    }
	                    base = inst.base;
	                } else {
	                    cbase = initialBase;
	                    toUnmount = initialChildComponent;
	                    if (toUnmount) cbase = component._component = null;
	                    if (initialBase || 1 === opts) {
	                        if (cbase) cbase._component = null;
	                        base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, !0);
	                    }
	                }
	                if (initialBase && base !== initialBase && inst !== initialChildComponent) {
	                    var baseParent = initialBase.parentNode;
	                    if (baseParent && base !== baseParent) {
	                        baseParent.replaceChild(base, initialBase);
	                        if (!toUnmount) {
	                            initialBase._component = null;
	                            recollectNodeTree(initialBase);
	                        }
	                    }
	                }
	                if (toUnmount) unmountComponent(toUnmount, base !== initialBase);
	                component.base = base;
	                if (base && !isChild) {
	                    var componentRef = component, t = component;
	                    while (t = t._parentComponent) (componentRef = t).base = base;
	                    base._component = componentRef;
	                    base._componentConstructor = componentRef.constructor;
	                }
	            }
	            if (!isUpdate || mountAll) mounts.unshift(component); else if (!skip) {
	                if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, previousContext);
	                if (options.afterUpdate) options.afterUpdate(component);
	            }
	            var fn, cb = component._renderCallbacks;
	            if (cb) while (fn = cb.pop()) fn.call(component);
	            if (!diffLevel && !isChild) flushMounts();
	        }
	    }
	    function buildComponentFromVNode(dom, vnode, context, mountAll) {
	        var c = dom && dom._component, originalComponent = c, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = getNodeProps(vnode);
	        while (c && !isOwner && (c = c._parentComponent)) isOwner = c.constructor === vnode.nodeName;
	        if (c && isOwner && (!mountAll || c._component)) {
	            setComponentProps(c, props, 3, context, mountAll);
	            dom = c.base;
	        } else {
	            if (originalComponent && !isDirectOwner) {
	                unmountComponent(originalComponent, !0);
	                dom = oldDom = null;
	            }
	            c = createComponent(vnode.nodeName, props, context);
	            if (dom && !c.nextBase) {
	                c.nextBase = dom;
	                oldDom = null;
	            }
	            setComponentProps(c, props, 1, context, mountAll);
	            dom = c.base;
	            if (oldDom && dom !== oldDom) {
	                oldDom._component = null;
	                recollectNodeTree(oldDom);
	            }
	        }
	        return dom;
	    }
	    function unmountComponent(component, remove) {
	        if (options.beforeUnmount) options.beforeUnmount(component);
	        var base = component.base;
	        component._disable = !0;
	        if (component.componentWillUnmount) component.componentWillUnmount();
	        component.base = null;
	        var inner = component._component;
	        if (inner) unmountComponent(inner, remove); else if (base) {
	            if (base[ATTR_KEY] && base[ATTR_KEY].ref) base[ATTR_KEY].ref(null);
	            component.nextBase = base;
	            if (remove) {
	                removeNode(base);
	                collectComponent(component);
	            }
	            var c;
	            while (c = base.lastChild) recollectNodeTree(c, !remove);
	        }
	        if (component.__ref) component.__ref(null);
	        if (component.componentDidUnmount) component.componentDidUnmount();
	    }
	    function Component(props, context) {
	        this._dirty = !0;
	        this.context = context;
	        this.props = props;
	        if (!this.state) this.state = {};
	    }
	    function render(vnode, parent, merge) {
	        return diff(merge, vnode, {}, !1, parent);
	    }
	    var options = {};
	    var stack = [];
	    var EMPTY_CHILDREN = [];
	    var lcCache = {};
	    var toLowerCase = function(s) {
	        return lcCache[s] || (lcCache[s] = s.toLowerCase());
	    };
	    var resolved = 'undefined' != typeof Promise && Promise.resolve();
	    var defer = resolved ? function(f) {
	        resolved.then(f);
	    } : setTimeout;
	    var EMPTY = {};
	    var ATTR_KEY = 'undefined' != typeof Symbol ? Symbol.for('preactattr') : '__preactattr_';
	    var NON_DIMENSION_PROPS = {
	        boxFlex: 1,
	        boxFlexGroup: 1,
	        columnCount: 1,
	        fillOpacity: 1,
	        flex: 1,
	        flexGrow: 1,
	        flexPositive: 1,
	        flexShrink: 1,
	        flexNegative: 1,
	        fontWeight: 1,
	        lineClamp: 1,
	        lineHeight: 1,
	        opacity: 1,
	        order: 1,
	        orphans: 1,
	        strokeOpacity: 1,
	        widows: 1,
	        zIndex: 1,
	        zoom: 1
	    };
	    var NON_BUBBLING_EVENTS = {
	        blur: 1,
	        error: 1,
	        focus: 1,
	        load: 1,
	        resize: 1,
	        scroll: 1
	    };
	    var items = [];
	    var nodes = {};
	    var mounts = [];
	    var diffLevel = 0;
	    var isSvgMode = !1;
	    var hydrating = !1;
	    var components = {};
	    extend(Component.prototype, {
	        linkState: function(key, eventPath) {
	            var c = this._linkedStates || (this._linkedStates = {});
	            return c[key + eventPath] || (c[key + eventPath] = createLinkedState(this, key, eventPath));
	        },
	        setState: function(state, callback) {
	            var s = this.state;
	            if (!this.prevState) this.prevState = clone(s);
	            extend(s, isFunction(state) ? state(s, this.props) : state);
	            if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
	            enqueueRender(this);
	        },
	        forceUpdate: function() {
	            renderComponent(this, 2);
	        },
	        render: function() {}
	    });
	    exports.h = h;
	    exports.cloneElement = cloneElement;
	    exports.Component = Component;
	    exports.render = render;
	    exports.rerender = rerender;
	    exports.options = options;
	});


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render(_ref, _ref2) {
	    _objectDestructuringEmpty(_ref2);
	
	    _objectDestructuringEmpty(_ref);
	
	    return (0, _preact.h)(
	      "section",
	      { "class": "about" },
	      (0, _preact.h)("div", { "class": "about-image" }),
	      (0, _preact.h)(
	        "div",
	        { "class": "flex flex-middle" },
	        (0, _preact.h)(
	          "h3",
	          { "class": "flex-auto" },
	          (0, _preact.h)(
	            "span",
	            { "class": "fa fa-user-circle" },
	            "\xA0"
	          ),
	          "About"
	        ),
	        (0, _preact.h)(
	          "div",
	          { "class": "social-links" },
	          (0, _preact.h)(
	            "a",
	            {
	              href: "https://www.instagram.com/rosenthalfitness/",
	              rel: "noopener noreferrer",
	              target: "_blank"
	            },
	            (0, _preact.h)("span", { "class": "fa fa-instagram" })
	          ),
	          (0, _preact.h)(
	            "a",
	            {
	              href: "https://www.facebook.com/RosenthalFitness",
	              rel: "noopener noreferrer",
	              target: "_blank"
	            },
	            (0, _preact.h)("span", { "class": "fa fa-facebook" })
	          )
	        )
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "Fitness is a crucial part of my life, I\u2019d like to make it a part of yours too."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "I have had numerous years of experience in the fitness industry. Coupled with being an amateur athlete for many years, I know what it's like to have the support system of a guide, or a trainer, and how imperative it can be to one's success."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "My desire to learn about fitness for myself has propelled me forward in being able to help others improve and become better. You can read more about me and how and why I became a personal trainer below."
	      ),
	      (0, _preact.h)(
	        "h4",
	        null,
	        "What's my purpose?"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "My purpose is to help you become better. Your fitness and health affects not only your physical abilities and looks but also your mental state and clarity."
	      ),
	      (0, _preact.h)(
	        "h4",
	        null,
	        "What does it mean to become better?"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "It means that you realize your immense potential as a human being to do marvelous things and care for your body like the gift that it is."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "Becoming better physically, means that you can run, jump, skip, lift or pull without hesitation and without the risk of injury regardless of your age!"
	      ),
	      (0, _preact.h)(
	        "h4",
	        null,
	        "So why should you become better?"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "Why not?"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "Get rid of that lingering tendonitis. shed those extra pounds. Gain more energy! I\u2019d like to lend you a hand. I\u2019d like to take you along with me on this journey of becoming better. You and me, together, becoming better."
	      ),
	      (0, _preact.h)(
	        "h4",
	        null,
	        "Are you ready? Let's go!!!"
	      ),
	      (0, _preact.h)(
	        "h4",
	        null,
	        "How did I get into personal training?"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "As a teenager I had a passion for martial arts. I always wanted to better myself. Become a stronger, more fierce, version of myself."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "As hard as I wanted to improve, I didn't have the guidance and proper instruction, so I had to improvise. I would train til exhaustion, the heavy bag, running, jump rope, you name it. But instead of improving I was slowly hurting myself."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "Daily i would put hours of hard work and sweat, but would not see any results, I was so frustrated. It was a disaster waiting to happen\u2026 And it did!"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "I began having pains throughout my body,  limping, and was having a hard time walking for more than 10 minutes at a time. A jog or a hike seemed impossible. I was extremely lethargic."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "I felt that my body had betrayed me. I was angry!"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "For two long years i was miserable.\u2026 full of anger and resentment toward everyone and their mother. My confidence was low. I couldn't bear to live like this! I had to do something."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "So I started researching my condition. I researched about doctors who could help me, some were instrumental and some less so. It took a while, but finally, with the right help, I figured out what was wrong with me -- it was called hip impingement."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "I ended up having a surgery. It helped quite a bit, but there was still pain and discomfort. And on top of it, now i was faced with the task of recovery."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "My recovery had to have been different than previously, I couldn't just go rogue again and expect a different result. This phase had to have been more thoughtful and diligent than my previous endeavours."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "So i started reading about proper ways of training and how the human body, and particularly muscles, work. Suddenly things were making sense. The more I studied, the more i understood why and how I got into this ditch at all, and how to get out of it."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "Since fitness has always been a passion of mine, and now having learned from my mistakes, I decided to become a personal trainer."
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "As I continue learning and develop even further, I would like to share my knowledge and passion with others so that they don't have to go through the same painful lessons I had gone through. My job is to help others become better and lead a better life."
	      )
	    );
	  };
	
	  return About;
	}(_preact.Component);
	
	exports.default = About;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	var _preactRouter = __webpack_require__(15);
	
	var _preactRouter2 = _interopRequireDefault(_preactRouter);
	
	var _header = __webpack_require__(8);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(7);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _home = __webpack_require__(9);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _availableSessions = __webpack_require__(4);
	
	var _availableSessions2 = _interopRequireDefault(_availableSessions);
	
	var _bookSession = __webpack_require__(5);
	
	var _bookSession2 = _interopRequireDefault(_bookSession);
	
	var _about = __webpack_require__(2);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _testimonials = __webpack_require__(10);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	var _contact = __webpack_require__(6);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  App.prototype.render = function render() {
	    return (0, _preact.h)(
	      'div',
	      { id: 'app' },
	      (0, _preact.h)(_header2.default, null),
	      (0, _preact.h)(
	        'div',
	        { 'class': 'scrollable' },
	        (0, _preact.h)(
	          _preactRouter2.default,
	          null,
	          (0, _preact.h)(_home2.default, { path: '/' }),
	          (0, _preact.h)(_availableSessions2.default, { path: '/book' }),
	          (0, _preact.h)(_bookSession2.default, { path: '/book/:ts' }),
	          (0, _preact.h)(_about2.default, { path: '/about' }),
	          (0, _preact.h)(_testimonials2.default, { path: '/testimonials' }),
	          (0, _preact.h)(_contact2.default, { path: '/contact' })
	        )
	      ),
	      (0, _preact.h)(_footer2.default, null)
	    );
	  };
	
	  return App;
	}(_preact.Component);
	
	exports.default = App;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AvailableSessions = function (_Component) {
	  _inherits(AvailableSessions, _Component);
	
	  function AvailableSessions() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AvailableSessions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      jsDate: new Date(),
	      sessions: [],
	      dateObj: {}
	    }, _this.onClickNextDate = function (e) {
	      e.preventDefault();
	      var jsDate = _this.state.jsDate;
	
	      var newJsDate = new Date();
	      newJsDate.setDate(jsDate.getDate() + 1);
	      _this.setState({ jsDate: newJsDate });
	    }, _this.onClickPrevDate = function (e) {
	      e.preventDefault();
	      var jsDate = _this.state.jsDate;
	
	      var newJsDate = new Date();
	      newJsDate.setDate(jsDate.getDate() - 1);
	      _this.setState({ jsDate: newJsDate });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AvailableSessions.prototype.componentWillMount = function componentWillMount() {
	    this.fetchSessions();
	  };
	
	  AvailableSessions.prototype.componentDidUpdate = function componentDidUpdate(props, _ref) {
	    var jsDate = _ref.jsDate;
	
	    if (jsDate !== this.state.jsDate) {
	      this.fetchSessions();
	    }
	  };
	
	  AvailableSessions.prototype.fetchSessions = function fetchSessions() {
	    var _this2 = this;
	
	    this.setState({
	      dateObj: {},
	      sessions: [],
	      isLoading: true
	    });
	    return fetch(("https://rosenthal-fitness.herokuapp.com") + "/sessions/" + +this.state.jsDate + "/available").then(function (r) {
	      return r.json();
	    }).then(function (json) {
	      _this2.setState({
	        sessions: json.sessions,
	        dateObj: json.date,
	        isLoading: false
	      });
	    });
	  };
	
	  AvailableSessions.prototype.render = function render() {
	    return (0, _preact.h)(
	      "section",
	      { "class": "available-sessions" },
	      (0, _preact.h)(
	        "h3",
	        null,
	        (0, _preact.h)(
	          "span",
	          { "class": "fa fa-calendar" },
	          "\xA0"
	        ),
	        " Book a Session"
	      ),
	      (0, _preact.h)(
	        "div",
	        null,
	        (0, _preact.h)(
	          "p",
	          null,
	          "To book a session, please contact Shaked Rosenthal:"
	        ),
	        (0, _preact.h)(
	          "p",
	          null,
	          (0, _preact.h)(
	            "a",
	            { "class": "underline", href: "/contact" },
	            "Via Contact Form"
	          )
	        ),
	        (0, _preact.h)(
	          "p",
	          null,
	          "Call/Text: (719) 271-7670"
	        )
	      )
	    );
	  };
	
	  AvailableSessions.prototype._render = function _render(_ref2, _ref3) {
	    var dateObj = _ref3.dateObj,
	        sessions = _ref3.sessions,
	        isLoading = _ref3.isLoading;
	
	    _objectDestructuringEmpty(_ref2);
	
	    return (0, _preact.h)(
	      "section",
	      { "class": "available-sessions" },
	      (0, _preact.h)(
	        "h3",
	        null,
	        (0, _preact.h)(
	          "span",
	          { "class": "fa fa-calendar" },
	          "\xA0"
	        ),
	        " Book a Session"
	      ),
	      (0, _preact.h)(
	        "div",
	        null,
	        isLoading ? (0, _preact.h)(
	          "h3",
	          null,
	          "Loading ..."
	        ) : (0, _preact.h)(
	          "h3",
	          { "class": "flex flex-wrap flex-middle flex-center" },
	          "Available Sessions for \xA0",
	          (0, _preact.h)(
	            "mark",
	            null,
	            (0, _preact.h)(
	              "a",
	              { href: "#", onClick: this.onClickPrevDate },
	              (0, _preact.h)("span", { "class": "fa fa-chevron-circle-left" })
	            ),
	            "\xA0",
	            dateObj.date,
	            "\xA0",
	            (0, _preact.h)(
	              "a",
	              { href: "#", onClick: this.onClickNextDate },
	              (0, _preact.h)("span", { "class": "fa fa-chevron-circle-right" })
	            )
	          )
	        ),
	        sessions.map(function (s) {
	          return (0, _preact.h)(AvailableSession, { start: s.start, end: s.end, trainer: "Shaked", location: "Seattle" });
	        })
	      )
	    );
	  };
	
	  return AvailableSessions;
	}(_preact.Component);
	
	exports.default = AvailableSessions;
	
	var AvailableSession = function (_Component2) {
	  _inherits(AvailableSession, _Component2);
	
	  function AvailableSession() {
	    _classCallCheck(this, AvailableSession);
	
	    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	  }
	
	  AvailableSession.prototype.render = function render(_ref4) {
	    var start = _ref4.start,
	        end = _ref4.end,
	        trainer = _ref4.trainer,
	        location = _ref4.location;
	
	    return (0, _preact.h)(
	      "article",
	      { "class": "available-session flex flex-wrap flex-middle" },
	      (0, _preact.h)(
	        "div",
	        null,
	        (0, _preact.h)(
	          "span",
	          { "class": "fa fa-clock-o" },
	          "\xA0"
	        ),
	        start.time,
	        " - ",
	        end.time
	      ),
	      (0, _preact.h)(
	        "div",
	        null,
	        (0, _preact.h)(
	          "span",
	          { "class": "fa fa-male" },
	          "\xA0"
	        ),
	        trainer
	      ),
	      (0, _preact.h)(
	        "div",
	        null,
	        (0, _preact.h)(
	          "span",
	          { "class": "fa fa-globe" },
	          "\xA0"
	        ),
	        location
	      ),
	      (0, _preact.h)(
	        "div",
	        null,
	        (0, _preact.h)(
	          "a",
	          { href: "/book/" + start.stamp, "class": "btn" },
	          (0, _preact.h)(
	            "span",
	            { "class": "fa fa-check" },
	            "\xA0"
	          ),
	          "Book"
	        )
	      )
	    );
	  };
	
	  return AvailableSession;
	}(_preact.Component);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	var _util = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookSession = function (_Component) {
	  _inherits(BookSession, _Component);
	
	  function BookSession() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BookSession);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { dateObj: {} }, _this.refCaptcha = function (el) {
	      _this.captchaEl = el;
	    }, _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var formData = (0, _util.simpleFormData)(e.target);
	      _this.bookSession(formData).then(function () {
	        _this.setState({
	          successfulBooking: true
	        });
	      }).catch(function () {
	        (0, _util.resetCaptcha)(_this.captchaEl);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BookSession.prototype.componentWillMount = function componentWillMount() {
	    this.updateHrDate();
	  };
	
	  BookSession.prototype.updateHrDate = function updateHrDate() {
	    var _this2 = this;
	
	    var sessionStartTs = this.props.ts;
	    return fetch(("https://rosenthal-fitness.herokuapp.com") + '/date/' + sessionStartTs).then(function (r) {
	      return r.json();
	    }).then(function (json) {
	      _this2.setState({ dateObj: json });
	    });
	  };
	
	  BookSession.prototype.componentDidMount = function componentDidMount() {
	    (0, _util.resetCaptcha)(this.captchaEl);
	  };
	
	  BookSession.prototype.bookSession = function bookSession(formData) {
	    return fetch(("https://rosenthal-fitness.herokuapp.com") + '/sessions', {
	      method: 'POST',
	      headers: { 'content-type': 'application/x-www-form-urlencoded' },
	      body: formData
	    }).then(function (r) {
	      console.log(r);
	      return r;
	    });
	  };
	
	  BookSession.prototype.render = function render(_ref, _ref2) {
	    var ts = _ref.ts;
	    var dateObj = _ref2.dateObj;
	
	    return (0, _preact.h)(
	      'section',
	      { 'class': 'book-session' },
	      (0, _preact.h)(
	        'h3',
	        { 'class': 'flex flex-middle flex-center flex-wrap' },
	        'Booking\xA0\xA0',
	        (0, _preact.h)(
	          'mark',
	          null,
	          dateObj.date,
	          ' @ ',
	          dateObj.time
	        )
	      ),
	      (0, _preact.h)(
	        'form',
	        { 'class': 'form-group', onSubmit: this.handleSubmit },
	        (0, _preact.h)('input', { name: 'sessionStartTs', type: 'hidden', value: ts }),
	        (0, _preact.h)(
	          'div',
	          { 'class': 'flex flex-middle' },
	          (0, _preact.h)(
	            'label',
	            null,
	            'Phone *'
	          ),
	          (0, _preact.h)('input', { name: 'trainee[phone]', placeholder: 'Your Phone', type: 'phone' })
	        ),
	        (0, _preact.h)(
	          'div',
	          { 'class': 'flex flex-middle' },
	          (0, _preact.h)(
	            'label',
	            null,
	            'Name *'
	          ),
	          (0, _preact.h)('input', { name: 'trainee[name]', placeholder: 'Your Name', type: 'text' })
	        ),
	        (0, _preact.h)(
	          'div',
	          { 'class': 'flex flex-middle' },
	          (0, _preact.h)(
	            'label',
	            null,
	            'Email *'
	          ),
	          (0, _preact.h)('input', { name: 'trainee[email]', placeholder: 'Your Email', type: 'email' })
	        ),
	        (0, _preact.h)(
	          'div',
	          { 'class': 'flex flex-middle' },
	          (0, _preact.h)(
	            'label',
	            null,
	            'Notes'
	          ),
	          (0, _preact.h)('textarea', { name: 'trainee[notes]', placeholder: 'Anything else you\'d like to share?' })
	        ),
	        (0, _preact.h)(
	          'div',
	          { 'class': 'flex recaptcha' },
	          (0, _preact.h)('label', null),
	          (0, _preact.h)('div', { ref: this.refCaptcha, 'class': 'g-recaptcha', 'data-sitekey': '6LdTshIUAAAAADdqSsgCAeRj5V-qQfB98Djqde6U' })
	        ),
	        (0, _preact.h)(
	          'div',
	          null,
	          (0, _preact.h)(
	            'button',
	            { 'class': 'btn' },
	            'Book!'
	          )
	        )
	      )
	    );
	  };
	
	  return BookSession;
	}(_preact.Component);
	
	exports.default = BookSession;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Contact.prototype.render = function render() {
	    return (0, _preact.h)(
	      "section",
	      { "class": "contact" },
	      (0, _preact.h)(
	        "h3",
	        null,
	        (0, _preact.h)(
	          "span",
	          { "class": "fa fa-envelope" },
	          "\xA0"
	        ),
	        " Contact"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "Please call or text @ (719) 271-7670"
	      )
	    );
	  };
	
	  return Contact;
	}(_preact.Component);
	
	exports.default = Contact;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return (0, _preact.h)(
	      "footer",
	      { "class": "flex" },
	      (0, _preact.h)(
	        "p",
	        { "class": "small" },
	        (0, _preact.h)(
	          "span",
	          { "class": "fa fa-copyright" },
	          "\xA0"
	        ),
	        new Date().getFullYear(),
	        "\xA0Rosenthal Fitness, LLC."
	      ),
	      (0, _preact.h)(
	        "div",
	        { "class": "flex-auto social-links" },
	        (0, _preact.h)(
	          "a",
	          {
	            href: "https://www.instagram.com/rosenthalfitness/",
	            rel: "noopener noreferrer",
	            target: "_blank"
	          },
	          (0, _preact.h)("span", { "class": "fa fa-instagram" })
	        ),
	        (0, _preact.h)(
	          "a",
	          {
	            href: "https://www.facebook.com/RosenthalFitness",
	            rel: "noopener noreferrer",
	            target: "_blank"
	          },
	          (0, _preact.h)("span", { "class": "fa fa-facebook" })
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_preact.Component);
	
	exports.default = Footer;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    return (0, _preact.h)(
	      "header",
	      { "class": "flex" },
	      (0, _preact.h)(
	        "a",
	        { href: "/" },
	        (0, _preact.h)(
	          "h1",
	          { "class": "logo" },
	          "ROSENTHAL FITNESS"
	        )
	      ),
	      (0, _preact.h)(
	        "a",
	        { "class": "menu-btn", href: "/" },
	        "| | |"
	      )
	    );
	  };
	
	  return Header;
	}(_preact.Component);
	
	exports.default = Header;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Home.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    [].map.call(this.ref.querySelectorAll('nav > a'), function (a) {
	      // me no work
	      var image = window.getComputedStyle(a, ':before').backgroundImage;
	    });
	
	    setTimeout(function () {
	      _this2.ref.classList.remove('loading');
	    }, 1000);
	  };
	
	  Home.prototype.render = function render() {
	    var _this3 = this;
	
	    return (0, _preact.h)(
	      'section',
	      { 'class': 'home loading', ref: function (el) {
	          return _this3.ref = el;
	        } },
	      (0, _preact.h)(
	        'nav',
	        { 'class': 'flex flex-wrap' },
	        (0, _preact.h)(
	          'a',
	          { href: '/book' },
	          (0, _preact.h)(
	            'h2',
	            null,
	            'Book a Session'
	          )
	        ),
	        (0, _preact.h)(
	          'a',
	          { href: '/contact' },
	          (0, _preact.h)(
	            'h2',
	            null,
	            'Contact'
	          )
	        ),
	        (0, _preact.h)(
	          'a',
	          { href: '/testimonials' },
	          (0, _preact.h)(
	            'h2',
	            null,
	            'Testimonials'
	          )
	        ),
	        (0, _preact.h)(
	          'a',
	          { href: '/about' },
	          (0, _preact.h)(
	            'h2',
	            null,
	            'About'
	          )
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_preact.Component);
	
	exports.default = Home;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _preact = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Testimonials = function (_Component) {
	  _inherits(Testimonials, _Component);
	
	  function Testimonials() {
	    _classCallCheck(this, Testimonials);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Testimonials.prototype.render = function render() {
	    return (0, _preact.h)(
	      "section",
	      { "class": "testimonials" },
	      (0, _preact.h)(
	        "h3",
	        null,
	        (0, _preact.h)(
	          "span",
	          { "class": "fa fa-microphone" },
	          "\xA0"
	        ),
	        " Testimonials"
	      ),
	      (0, _preact.h)(
	        "p",
	        null,
	        "Want to help out? Feel free to ",
	        (0, _preact.h)(
	          "a",
	          { href: "/contact", "class": "underline" },
	          "reach out!"
	        )
	      ),
	      (0, _preact.h)(
	        "div",
	        { "class": "quote" },
	        (0, _preact.h)(
	          "p",
	          null,
	          "Shaked is an amazing person and trainer. I worked a year with him and throughout that time I made an amazing friend. I had goals to meet and happily made them.  We had some bumps in the road with injuries,  but he was patient, kind and encouraging. When I was feeling down on myself, he knew how to lift me up and encourage me. Somedays I would tear up with happy tears hearing his encouraging words. His patience was greatly appreciated and he explained why we were taking it slow yet still keeping me on track."
	        ),
	        (0, _preact.h)(
	          "p",
	          null,
	          "I am very lucky to have had him as my trainer and blessed to call him my friend."
	        )
	      ),
	      (0, _preact.h)(
	        "p",
	        { "class": "name" },
	        " Charity "
	      ),
	      (0, _preact.h)(
	        "div",
	        { "class": "quote" },
	        (0, _preact.h)(
	          "p",
	          null,
	          "After having two children, my lifestyle became sedentary for a couple of years.  On a trajectory of weight gain and less activity, I decided to train with Shaked two times a week for one year.  Shaked provided the accountability, knowledge, and consistency to support me in safely reaching my goals; return to a level of general fitness where I felt comfortable to do regular exercise like jogging, and gradual healthy weight loss that I was unable to do on my own after having children.  Additionally, Shaked helped me learn to utilize tools for improving my diet.  The combination of providing variety in workouts and plenty of positive encouragement and patience helped me gradually and safely build strength and endurance.  Though a secondary goal, I lost over 20 lbs in 8 months and achieved a level of strength I am satisfied to maintain several months after completion of the program. Shaked is an enthusiastic trainer with a good work ethic, sensitivity, and patience for someone starting even at beginner levels. I would recommend him to anyone!"
	        )
	      ),
	      (0, _preact.h)(
	        "p",
	        { "class": "name" },
	        " Sara "
	      ),
	      (0, _preact.h)(
	        "div",
	        { "class": "quote" },
	        (0, _preact.h)(
	          "p",
	          null,
	          "Shaked has been my personal trainer for the 18 months. I highly recommend him!  He has kept me motivated and on track to achieving my long term goals. Working with him has made a huge difference in my quality of life."
	        ),
	        (0, _preact.h)(
	          "p",
	          null,
	          "Shaked has designed a custom workout program which specifically address my long term goals. We have together successfully strengthened my muscles and improved both my posture and my balance. This has made a huge difference in my life, because I am now able to walk my dog, carry my backpack, and garden to my heart's content. I am able to do these activities now in spite of the arthritis in my knees. Before I started working out with Shaked, I had had multiple sessions of physical therapy, which had only marginally addressed my issues."
	        ),
	        (0, _preact.h)(
	          "p",
	          null,
	          "Shaked fine tunes each session to address what is going on with me on that day. At the beginning of the session we talk about how I am feeling and what kinds of problems I might be having. He knows that I am someone who actually would rather be almost anywhere else than a gym, so he makes the workout fun by choosing a variety of exercises. He keeps me going throughout the workout with encouraging words. The workouts are also varied to ensure that I get a whole body workout over the course of a week."
	        ),
	        (0, _preact.h)(
	          "p",
	          null,
	          "Shaked pays a lot of attention to me as I am working out to make sure that I am doing each exercise with proper form and with an appropriate amount of weight or resistance. He makes sure that I am stretching. I feel very safe when working out under Shaked's supervision."
	        ),
	        (0, _preact.h)(
	          "p",
	          null,
	          "Lastly, Shaked works with me to help me to arrange a schedule that works for my complicated and busy life. He encourages me to keep making the time to workout. This has been tremendously helpful to me because I have found that exercise is the best thing for me to do to counteract the stress in my life. I am currently studying about 70 hours a week and I am thriving in spite of the stress."
	        )
	      ),
	      (0, _preact.h)(
	        "p",
	        { "class": "name" },
	        " Carrie "
	      )
	    );
	  };
	
	  return Testimonials;
	}(_preact.Component);
	
	exports.default = Testimonials;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.simpleFormData = simpleFormData;
	exports.mountCaptcha = mountCaptcha;
	exports.resetCaptcha = resetCaptcha;
	function simpleFormData(form) {
	  return Array.from(new FormData(form).entries()).map(function (_ref) {
	    var key = _ref[0],
	        value = _ref[1];
	    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
	  }).join('&');
	}
	
	function mountCaptcha(captchaEl) {
	  window.grecaptcha && window.grecaptcha.render(captchaEl, {
	    sitekey: '6LdTshIUAAAAADdqSsgCAeRj5V-qQfB98Djqde6U'
	  });
	}
	
	function resetCaptcha() {
	  window.grecaptcha && window.grecaptcha.reset();
	}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
12,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(16);
	module.exports = self.fetch.bind(self);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["preact"],e):t.preactRouter=e(t.preact)}(this,function(t){function e(t,e){for(var n in e)t[n]=e[n];return t}function n(t,e,n){var r,o=/(?:\?([^#]*))?(#.*)?$/,u=t.match(o),a={};if(u&&u[1])for(var p=u[1].split("&"),c=0;c<p.length;c++){var f=p[c].split("=");a[decodeURIComponent(f[0])]=decodeURIComponent(f.slice(1).join("="))}t=i(t.replace(o,"")),e=i(e||"");for(var l=Math.max(t.length,e.length),s=0;s<l;s++)if(e[s]&&":"===e[s].charAt(0)){var h=e[s].replace(/(^\:|[+*?]+$)/g,""),d=(e[s].match(/[+*?]+$/)||C)[0]||"",g=~d.indexOf("+"),m=~d.indexOf("*"),y=t[s]||"";if(!y&&!m&&(d.indexOf("?")<0||g)){r=!1;break}if(a[h]=decodeURIComponent(y),g||m){a[h]=t.slice(s).map(decodeURIComponent).join("/");break}}else if(e[s]!==t[s]){r=!1;break}return(!0===n.default||!1!==r)&&a}function r(t,e){return t.rank<e.rank?1:t.rank>e.rank?-1:t.index-e.index}function o(t,e){return t.index=e,t.rank=p(t),t.attributes}function i(t){return t.replace(/(^\/+|\/+$)/g,"").split("/")}function u(t){return":"==t.charAt(0)?1+"*+?".indexOf(t.charAt(t.length-1))||4:5}function a(t){return i(t).map(u).join("")}function p(t){return t.attributes.default?0:a(t.attributes.path)}function c(t){return null!=t.__preactattr_||"undefined"!=typeof Symbol&&null!=t[Symbol.for("preactattr")]}function f(t,e){void 0===e&&(e="push"),R&&R[e]?R[e](t):"undefined"!=typeof history&&history[e+"State"]&&history[e+"State"](null,null,t)}function l(){var t;return t=R&&R.location?R.location:R&&R.getCurrentLocation?R.getCurrentLocation():"undefined"!=typeof location?location:x,""+(t.pathname||"")+(t.search||"")}function s(t,e){return void 0===e&&(e=!1),"string"!=typeof t&&t.url&&(e=t.replace,t=t.url),h(t)&&f(t,e?"replace":"push"),d(t)}function h(t){for(var e=U.length;e--;)if(U[e].canRoute(t))return!0;return!1}function d(t){for(var e=!1,n=0;n<U.length;n++)!0===U[n].routeTo(t)&&(e=!0);for(var r=k.length;r--;)k[r](t);return e}function g(t){if(t&&t.getAttribute){var e=t.getAttribute("href"),n=t.getAttribute("target");if(e&&e.match(/^\//g)&&(!n||n.match(/^_?self$/i)))return s(e)}}function m(t){if(0==t.button)return g(t.currentTarget||t.target||this),y(t)}function y(t){return t&&(t.stopImmediatePropagation&&t.stopImmediatePropagation(),t.stopPropagation&&t.stopPropagation(),t.preventDefault()),!1}function v(t){if(!(t.ctrlKey||t.metaKey||t.altKey||t.shiftKey||0!==t.button)){var e=t.target;do{if("A"===(e.nodeName+"").toUpperCase()&&e.getAttribute("href")&&c(e)){if(e.hasAttribute("native"))return;if(g(e))return y(t)}}while(e=e.parentNode)}}function b(){_||("function"==typeof addEventListener&&(R||addEventListener("popstate",function(){d(l())}),addEventListener("click",v)),_=!0)}var C={},R=null,U=[],k=[],x={},_=!1,A=function(i){function u(t){i.call(this,t),t.history&&(R=t.history),this.state={url:t.url||l()},b()}return i&&(u.__proto__=i),u.prototype=Object.create(i&&i.prototype),u.prototype.constructor=u,u.prototype.shouldComponentUpdate=function(t){return!0!==t.static||(t.url!==this.props.url||t.onChange!==this.props.onChange)},u.prototype.canRoute=function(t){return this.getMatchingChildren(this.props.children,t,!1).length>0},u.prototype.routeTo=function(t){return this._didRoute=!1,this.setState({url:t}),this.updating?this.canRoute(t):(this.forceUpdate(),this._didRoute)},u.prototype.componentWillMount=function(){U.push(this),this.updating=!0},u.prototype.componentDidMount=function(){var t=this;R&&(this.unlisten=R.listen(function(e){t.routeTo(""+(e.pathname||"")+(e.search||""))})),this.updating=!1},u.prototype.componentWillUnmount=function(){"function"==typeof this.unlisten&&this.unlisten(),U.splice(U.indexOf(this),1)},u.prototype.componentWillUpdate=function(){this.updating=!0},u.prototype.componentDidUpdate=function(){this.updating=!1},u.prototype.getMatchingChildren=function(i,u,a){return i.filter(o).sort(r).map(function(r){var o=n(u,r.attributes.path,r.attributes);if(o){if(!1!==a){var i={url:u,matches:o};return e(i,o),delete i.ref,delete i.key,t.cloneElement(r,i)}return r}}).filter(Boolean)},u.prototype.render=function(t,e){var n=t.children,r=t.onChange,o=e.url,i=this.getMatchingChildren(n,o,!0),u=i[0]||null;this._didRoute=!!u;var a=this.previousUrl;return o!==a&&(this.previousUrl=o,"function"==typeof r&&r({router:this,url:o,previous:a,active:i,current:u})),u},u}(t.Component),I=function(n){return t.h("a",e({onClick:m},n))},L=function(e){return t.h(e.component,e)};return A.subscribers=k,A.getCurrentUrl=l,A.route=s,A.Router=A,A.Route=L,A.Link=I,A});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// bundle.2e00bdd1a973b1a85c53.js